import { Component, inject } from '@angular/core';

import { RegisterComponent } from '../component-lookup';
import { GlobalConstants } from '../../../shared/global-constants';
import { StateService } from '../../services/state.service';

@RegisterComponent('Legend')
@Component({
  selector: 'app-legend',
  standalone: true,
  imports: [],
  templateUrl: './legend.component.html',
  styleUrl: './legend.component.scss'
})
export class LegendComponent {
  private stateService = inject(StateService);
  readonly institution = this.stateService.institution;
  readonly peer = this.stateService.peer;
  readonly peerName = this.stateService.peerName;
  readonly rate = this.stateService.rate;

  public institutionColor = GlobalConstants.colors[0];
  public peerColor = GlobalConstants.colors[1];
  public rateColor = GlobalConstants.rateColor;
}
